<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page mt-1 border-container-report" id="preview-logbook-valued">
        <thead id="thead">
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{equipmentLogbookPrintModel.equipmentLogbookId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{equipmentLogbookPrintModel.equipmentLogbookId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.branchName}}</p>

                  <!-- Tipo de Hoja de Vida -->
                  <p id="hoja-vida-tipo-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">Hoja de vida - Valorizada</p>

                  <!-- Fecha Actual -->
                  <label id="t-fecha-actual-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-fecha-actual' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-actual-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{dateNow | date: 'dd/MM/yyyy'}}</p>

                  <!-- Equipo -->
                  <label id="t-equipo-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-equipo' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="equipo-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.equipmentName}}</p>

                  <!-- Equipo Código  -->
                  <label id="t-equipo-codigo-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-equipo-codigo' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="equipo-codigo-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.equipmentCode}}</p>

                  <!-- Equipo Marca -->
                  <label id="t-marca-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-marca' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="marca-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.trademark}}</p>

                  <!-- Equipo Referencia -->
                  <label id="t-referencia-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-referencia' | formatLabelPipe : elementsLabel}}</label>
                  <p id="referencia-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.reference}}</p>

                  <!-- Equipo Serie -->
                  <label id="t-serie-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-serie' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="serie-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.serie}}</p>

                  <!-- Equipo Nombre Comercial -->
                  <label id="t-nombre-comercial-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-nombre-comercial' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nombre-comercial-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.commercialName}}</p>

                  <!-- Equipo Tipo Equipo -->
                  <label id="t-tipo-equipo-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-tipo-equipo' | formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-equipo-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.equipmentType}}</p>

                  <!-- Equipo Proveedor -->
                  <label id="t-proveedor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-proveedor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="proveedor-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.provider}}</p>

                  <!-- Equipo Varlor Compra -->
                  <label id="t-valor-compra-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-valor-compra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-compra-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.purchaseValue | currency:'':''}}</p>

                  <!-- Equipo Capacidad -->
                  <label id="t-capacidad-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-capacidad' | formatLabelPipe : elementsLabel}}</label>
                  <p id="capacidad-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.capacity}}</p>

                  <!-- Numero de factura -->
                  <label id="t-numero-factura-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-numero-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="numero-factura-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.invoiceNumber}}</p>

                  <!-- Fecha Compra -->
                  <label id="t-fecha-compra-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-fecha-compra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-compra-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.purchaseDate | date: 'dd/MM/yyyy'}}</p>

                  <!-- Fecha Incio Garantia -->
                  <label id="t-garantia-ini-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-garantia-ini' | formatLabelPipe : elementsLabel}}</label>
                  <p id="garantia-ini-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.warrantyInitialDate | date: 'dd/MM/yyyy'}}</p>

                  <!-- Fecha Fin Garantia -->
                  <label id="t-garantia-fin-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-garantia-fin' | formatLabelPipe : elementsLabel}}</label>
                  <p id="garantia-fin-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.warrantyFinalDate | date: 'dd/MM/yyyy'}}</p>

                  <!-- Equipo Año de Fabricación -->
                  <label id="t-ano-fabricacion-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-ano-fabricacion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="ano-fabricacion-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.yearManufacture}}</p>

                  <!-- Equipo Tipo Motor -->
                  <label id="t-tipo-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-tipo-motor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.engineType}}</p>

                  <!-- Equipo Codigo Motor -->
                  <label id="t-codigo-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-codigo-motor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="codigo-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.engineCode}}</p>

                  <!-- Equipo Referencia Motor -->
                  <label id="t-referencia-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-referencia-motor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="referencia-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.referenceEngine}}</p>

                  <!-- Equipo Marca Motor -->
                  <label id="t-marca-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-marca-motor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="marca-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.trademarkEngine}}</p>

                  <!-- Equipo Serie Motor -->
                  <label id="t-serie-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-serie-motor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="serie-motor-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{equipmentLogbookPrintModel.serieEngine}}</p>

                  <!-- Equipo Voltaje -->
                  <label id="t-voltaje-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-voltaje' | formatLabelPipe : elementsLabel}}</label>
                  <p id="voltaje-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.voltage}}</p>

                  <!-- Equipo Potencia -->
                  <label id="t-potencia-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-potencia' | formatLabelPipe : elementsLabel}}</label>
                  <p id="potencia-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.power}}</p>

                  <!-- Equipo Amperaje -->
                  <label id="t-amperaje-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-amperaje' | formatLabelPipe : elementsLabel}}</label>
                  <p id="amperaje-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{equipmentLogbookPrintModel.amperage}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr>
            <td>
              <div *ngFor="let detail of equipmentLogbookPrintModel.equipmentLogbookDetails" class="px-1">
                <div id="branch-style" class="d-flex justify-content-between">
                  <!-- Sucursal -->
                  <p id="body-group-nombre-sucursal-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    class="body-group-nombre-sucursal" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{detail.branch}}</p>

                  <p id="body-group-total-sucursal-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                    class="body-group-total-sucursal" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{detail.totalValueBranch |
                    currency:'':''}}</p>
                </div>
                <div *ngFor="let maintenance of detail.maintenanceOrderByBranches">
                  <!-- Ordenes Matenimiento -->
                  <div class="maintenance-style">
                    <p id="body-group-orden-mantenimiento-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                      class="body-group-orden-mantenimiento" (mousedown)="onMouseDown($event)"
                      (dragstart)="onDragStart()"> Orden Mantenimiento:
                      {{maintenance.maintenanceOrderConsecutive}} - Tipo:
                      {{maintenance.maintenanceOrderType}} - Tipo Mtto: {{maintenance.maintenanceType}} - Fecha
                      Ini:{{maintenance.dateInitialMaintenanceOrder | date : 'dd/MM/yyyy'}} - Fecha Fin:
                      {{maintenance.dateFinalMaintenanceOrder | date : 'dd/MM/yyyy'}}</p>
                  </div>
                  <div class="ps-3">
                    <!-- Horometro -->
                    <p id="body-group-horometro-kms-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                      class="body-group-horometro-kms" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                      Horometro/Kms:
                      {{maintenance.kmHoromValue | currency:'':''}}</p>

                    <!-- Diagnostico inicial -->
                    <p id="body-group-diagnostico-inicial-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                      class="body-group-diagnostico-inicial lh-1 text-format" (mousedown)="onMouseDown($event)"
                      (dragstart)="onDragStart()">{{maintenance.initialDiagnosis}}</p>

                    <!-- Diagnostico final -->
                    <p id="body-group-diagnostico-final-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                      class="body-group-diagnostico-final pt-1 lh-1 text-format" (mousedown)="onMouseDown($event)"
                      (dragstart)="onDragStart()">{{maintenance.finalDiagnosis}}</p>
                  </div>
                  <div *ngIf="maintenance.equipmentLogbookRepairs.length > 0" class="table-container mb-2 mt-1">
                    <!-- Tabla ordenes mantenimientos -->
                    <app-custom-table-print id="detalle-hoja-vida-{{maintenance.maintenanceOrderId}}"
                      [columns]="columns" [data]="maintenance.equipmentLogbookRepairs" [idMap]="idMap"
                      [documentId]="maintenance.maintenanceOrderId" [footerVisible]="true" [editFormat]="editFormat"
                      (clickTableEvent)="clickTable($event)"
                      (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
                  </div>
                </div>
              </div>
              <div *ngIf="equipmentLogbookPrintModel.equipmentLogbookTotals.length > 0"
                class="container-totals mb-1 px-1">
                <!-- Totales facturados del equipo -->
                <label id="t-foot-facturas-{{equipmentLogbookPrintModel.equipmentLogbookId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-foot-facturas' | formatLabelPipe : elementsLabel}}</label>

                <div class="table-container">
                  <p-table [value]="equipmentLogbookPrintModel.equipmentLogbookTotals" [columns]="columnsTotals"
                    [reorderableColumns]="editFormat" (onColReorder)="onColumnReorderTotals()"
                    [rowGroupMode]="'subheader'" [groupRowsBy]="'branchCode'" [sortField]="'branchCode'"
                    sortMode="single" styleClass="p-datatable-sm" showGridlines>
                    <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columnsTotals" pReorderableColumn
              [id]="'th-' + idMapTotals[col.field].id + '-' + equipmentLogbookPrintModel.equipmentLogbookId"
              (click)="clickTable($event)" [class]=" idMapTotals[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columnsTotals" [id]="'td-' + idMapTotals[col.field].id + '-' + rowData.id"
                (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMapTotals[col.field].type}}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="groupheader" let-detail>
            <tr class="row-group-footer">
              <td [attr.colspan]="columnsTotals.length">
                <div class="summary-flex-container"
                  *ngIf="getGroupInfo(equipmentLogbookPrintModel.equipmentLogbookId, detail.branchCode) as info">
                  <!-- sucursal y valor total -->
                  <p id="foot-group-branch-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (click)="onClick()"
                    class="foot-group-branch" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                    info.branchCodeName }} </p>

                  <p id="foot-group-total-{{equipmentLogbookPrintModel.equipmentLogbookId}}" (click)="onClick()"
                    class="foot-group-total" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                    info.totalValueBranch | currency:'':'' }}</p>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>
    </div>
  </div>
  </td>
  </tr>
  </tbody>
  <tfoot id="td-foot">
    <tr>
      <td colspan="1">
        <div id="foot-{{equipmentLogbookPrintModel.equipmentLogbookId}}" class="foot p-1">
          <div [ngClass]="paperSize == paperSizeFormat ? 'footer' : ''" class="informationPrint d-flex"
            class="informationPrint d-flex">
            <!-- Versión-->
            <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>

            <!-- Fecha Impresión-->
            <label id="t-fecha-impresion" class="fw-bold pe-2">
              {{'t-fecha-impresion' | formatLabelPipe : elementsLabel}}</label>
            <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>

            <!-- Hora Impresión-->
            <label id="t-hora-impresion" class="fw-bold pe-2">
              {{'t-hora-impresion' | formatLabelPipe : elementsLabel}}</label>
            <p id="hora-impresion" class="pe-4">{{dateNow | date: 'hh:mm:ss a'}}</p>

            <!-- Usuario Impresión-->
            <label id="t-usuario-impresion" class="fw-bold pe-2">
              {{'t-usuario-impresion' | formatLabelPipe : elementsLabel}}</label>
            <p id="usuario-impresion" class="pe-4">{{equipmentLogbookPrintModel.userAuthenticated}}</p>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <div class="d-flex justify-content-center">
              <p class="informationPrint">Documento generado con el Software Cervino Web de Altos Software
                SAS. Nit.811.022.121-1. www.altos-soft.com</p>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tfoot>
  </table>
  </div>
  </div>
</section>